import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http/http.service';

import * as pdfjsLib from 'pdfjs-dist';
import { ActivatedRoute } from '@angular/router/router';
import { HttpClient } from '@angular/common/http';
(pdfjsLib as any).GlobalWorkerOptions.workerSrc = '/assets/pdfjs/pdf.worker.min.js';


@Component({
  selector: 'app-claim-qr-code',
  templateUrl: './claim-qr-code.component.html',
  styleUrls: ['./claim-qr-code.component.scss']
})
export class ClaimQrCodeComponent implements OnInit {

  constructor(
    private changeDetection: ChangeDetectorRef,
    private httpSv: HttpService,
    private _snackBar: MatSnackBar,
    private toster: ToastrService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const payload = params['payload'];
      if (payload) {
        try {
          // 1. Decode Base64
          const decodedString = atob(payload);

          // 2. Parse as URL query string, not JSON
          const searchParams = new URLSearchParams(decodedString);

          this.restoId = searchParams.get('restaurant_id');
          this.restoName = searchParams.get('restaurant_name');
          this.restoAddress = searchParams.get('address');
          this.restoLogo = searchParams.get('logo');
          this.restoApproved = searchParams.get('approved') === '1' ? 1 : 0;

          console.log("Decoded data:", {
            restaurant_id: this.restoId,
            restaurant_name: this.restoName,
            address: this.restoAddress,
            logo: this.restoLogo,
            approved: this.restoApproved,
          });

        } catch (e) {
          console.error("Error decoding payload:", e);
        }
      } else {
        console.warn("No payload found in the URL.");
      }
    });

  }

  restoId: string = null;
  restoName: string = null;
  restoLogo: string = null;
  restoAddress: string = null;
  restoApproved: 0 | 1 = null; // 0 for not approved, 1 for approved



  logoToBeAppend: File = null;
  fileName: string = '';
  onImageChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    // if (fileSize > 500) {
    //   this.toster.info(`Image can't be uploaded, as the size is bigger than 500 kb`, '', {
    //     timeOut: 11000,
    //   })
    //   document.getElementById(id)['value'] = ''
    //   return
    // }
    this.logoToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    this.fileName = file.name;
    document.getElementById(id)['value'] = ''




    const fileType = file.type;

    if (fileType === 'application/pdf') {
      this.handlePdf(file);  // handle PDF separately
    } else if (fileType.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Image = reader.result;
        // Do something with base64Image
      };
      reader.readAsDataURL(file);
    }

  }

  pdfImages: string[] = []; // Array to store generated images from PDF

  async handlePdf(file: File) {
    const reader = new FileReader();
    console.log('Handling PDF file:', file);
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result as ArrayBuffer);
      const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;

      const pageCount = pdf.numPages;

      for (let pageNum = 1; pageNum <= pageCount; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d')!;
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };

        await page.render(renderContext).promise;

        const imageDataUrl = canvas.toDataURL('image/jpeg'); // or image/png

        this.pdfImages.push(imageDataUrl);
      }
    };

    reader.readAsArrayBuffer(file);
  }

  loaderFlag: boolean = false;
  successLoadFlag: boolean = false;
  qrCodeUrl: string = null;
  onSubmit() {

    if (this.pdfImages.length == 0) {
      this.toster.info('Please upload a PDF file', '', {
        timeOut: 2000,
      })
      return
    }


    let payload = {
      base64_images: this.pdfImages,
      restaurant_id: this.restoId,
      restaurant_name: this.restoName,
      restaurant_approved: this.restoApproved
    }

    this.loaderFlag = true;
    this.successLoadFlag = false;
    this.httpSv.readMenuImages(payload).subscribe((res: any) => {
      if (res['status']) {
        this.loaderFlag = false;
        this.successLoadFlag = true;
        this.qrCodeUrl = res.qr_code;
        this.changeDetection.detectChanges();
        this._snackBar.open(res['message'], '', {
          duration: 2000,
        });

        console.log(this.successLoadFlag)
      }
      else {
        this.loaderFlag = false;
        this._snackBar.open(res['message'], '', {
          duration: 2000,
        });
      }
    }, (err) => {
      this.toster.error('Opps! Something went wrong', '', { timeOut: 2000 })
      this.loaderFlag = false;
    })


  }

  downLoadQrWeb() {
    if (this.qrCodeUrl) {
      const imgName = this.qrCodeUrl.substr(this.qrCodeUrl.lastIndexOf("/") + 1);
      this.preloadingFlag = true
      this.httpClient
        .get(this.qrCodeUrl, { responseType: "blob" as "json" })
        .subscribe((res: any) => {
          const file = new Blob([res], { type: res.type });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
            return;
          }
          this.preloadingFlag = false
          const blob = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = blob;
          link.download = imgName;
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          setTimeout(() => {
            window.URL.revokeObjectURL(blob);
            link.remove();
          }, 100);
        }, err => {
          this.preloadingFlag = false
          this.toster.error('Error downloading QR code', '', { timeOut: 2000 });
        });
    }

  }







  otpFlag: boolean = false;
  enteredOtp: string = '';
  // selectedEmailToVerify: string = 'suryansh@iglulabs.com'; // need to change later on
  selectedEmailToVerify: string = null; // need to change later on
  preloadingFlag: boolean = false;
  otpData: string = '';

  resendOtp() {
    this.getOtp()
  }
  getOtp() {

    if (this.fileName == '' || this.fileName == null) {
      this.toster.info('Please upload a file first', '', {
        timeOut: 2000,
      })
      return
    }

    if (!this.selectedEmailToVerify) return

    this.preloadingFlag = true

    this.httpSv.sendOtpByEmail(this.selectedEmailToVerify.trim()).subscribe((res:any) => {
      if (res['status'] == 'TRUE') {
        this.preloadingFlag = false
        const b64 = res.result.data; // base64 string
        const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
        const decodedObj = JSON.parse(decodedStr);

        this.otpData = decodedObj.otp;
        // this.otpData = res['result'].data.otp
        this.otpFlag = true;
      }
      else {
        this._snackBar.open(res['message'])
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000);
      }
    }, err => {
      this._snackBar.open('Opps! Something went wrong')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000);
    })
  }

  verifyOtp(e: any = null) {
    if (this.enteredOtp.length != 4) return
    if (this.enteredOtp == this.otpData) {
      this.onSubmit()
    }
    else {
      this._snackBar.open("OTP is not valid")
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000);
    }
  }




  otp: string[] = ['', '', '', ''];

  @ViewChildren('otp0, otp1, otp2, otp3') otpInputs!: QueryList<ElementRef>;

  moveToNext(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    if (value.length === 1 && index < 3) {
      const nextInput = this.otpInputs.toArray()[index + 1];
      nextInput.nativeElement.focus();
    }

    // Optional: Handle backspace to move focus back
    if (value.length === 0 && event.inputType === 'deleteContentBackward' && index > 0) {
      const prevInput = this.otpInputs.toArray()[index - 1];
      prevInput.nativeElement.focus();
    }

    this.enteredOtp = this.otp.join('');
  }

}
